import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { getAllEmailAccounts, getEmailAccountById } from '../../api/emailAccountsService';

import { emailAccountsKeys } from './keys';

/**
 * Query options for fetching all email accounts
 */
export const allEmailAccountsOptions = () =>
	queryOptions({
		queryKey: emailAccountsKeys.all,
		queryFn: async () => {
			const response = await getAllEmailAccounts();
			return response.accounts ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});

/**
 * Hook to fetch all email accounts
 */
export function useAllEmailAccounts() {
	return useQuery(allEmailAccountsOptions());
}

/**
 * Query options for fetching single email account by ID
 */
export const emailAccountByIdOptions = (accountId) =>
	queryOptions({
		queryKey: emailAccountsKeys.detail(accountId),
		queryFn: async () => {
			if (!accountId) return null;
			const response = await getEmailAccountById(accountId);
			return response.account;
		},
		enabled: Boolean(accountId),
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});

/**
 * Hook to fetch single email account by ID
 */
export function useEmailAccountById(accountId) {
	return useQuery(emailAccountByIdOptions(accountId));
}
